import React from 'react';
import {Checkbox} from '../Input/Input';
import StandardFieldset from "../UI/StandardFieldset";
import { useTranslation } from 'react-i18next';
import { googleDataLayer } from '../Analytics/Universal/PageView/googleDataLayer';

const Marketing = (props) => {

  const { t } = useTranslation('common');

  const onChange = (event) => {
    googleDataLayer.createCheckboxClickEvent("agreedMarketing", event.target.checked);
    props.setValue("marketing", event.target.checked, { shouldValidate: true });
  };

  return (
    <>
    <StandardFieldset className='marketingFieldset' id="marketing-pane">
        <Checkbox
          register={props.register}
          errors={props.errors}
          name={'marketing'}
          required={false}
          control={props.control}
          label={t('i-would-like-to-receive-holiday-updates-offers-and')}
          touched={props.touchedFields['marketing']}
          onChange={(e) => onChange(e)}
        />
    </StandardFieldset>
    </>
  );
};

export default Marketing;